// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".volume-source[data-v-394b651c]{padding:20px;margin:20px 0 20px 0;position:relative}.volume-source[data-v-394b651c] .code-mirror .CodeMirror,.volume-source[data-v-394b651c] .code-mirror .CodeMirror .CodeMirror-gutters{background-color:var(--yaml-editor-bg)}.remove-vol[data-v-394b651c]{position:absolute;top:10px;right:10px;padding:0}.add-vol[data-v-394b651c]:focus{outline:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
